import { render, staticRenderFns } from "./bullDueForCulling.vue?vue&type=template&id=75de48f6&scoped=true&"
import script from "./bullDueForCulling.vue?vue&type=script&lang=js&"
export * from "./bullDueForCulling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75de48f6",
  null
  
)

export default component.exports